export const STENCIL_TOKENS_NAMESPACE = 'st-dt';
export const TOKEN_NOT_FOUND_CSS_VAR = "--".concat(STENCIL_TOKENS_NAMESPACE, "-token-not-found");
export const PREFERS_COLOR_SCHEME_DARK = 'dark';
export const PREFERS_COLOR_SCHEME_ID = 'data-stencil-prefers-color-scheme';
export const PREFERS_COLOR_SCHEME_DARK_SELECTOR = "[".concat(PREFERS_COLOR_SCHEME_ID, "=").concat(PREFERS_COLOR_SCHEME_DARK, "]");
export const TOKEN_REGEX = /^[a-z]+(\.[a-z0-9-]+)+$/i;